export default function PriceTag({ amount, suffix, loading = false }) {
  if (loading) {
    return <div className="mt-1 h-8 w-20 animate-pulse rounded bg-white/10" />;
  }
  return (
    <div className="mt-1 flex items-baseline gap-1">
      <span className="text-2xl font-extrabold tracking-tight text-hc-text">
        {amount ?? "—"}
      </span>
      {suffix && <span className="text-xs text-hc-text-dim">{suffix}</span>}
    </div>
  );
}
